import * as React from 'react';
import { TabStyles } from '../../styles/TabStyles';
import { assertNever } from './ChromeTooltipUtility';

export const Height = 12;

export const Width = 6;

const Stroke = TabStyles.Colors.L5;

const Fill = TabStyles.Colors.White;

const StrokeWidth = TabStyles.Sizing.BorderWidth;

export type Direction = 'Up' | 'Down' | 'Left' | 'Right';

export interface ChromeTooltipArrowProps {
  readonly direction: Direction;
}

export function ChromeTooltipArrow(
  { direction, style }: ChromeTooltipArrowProps & React.SVGProps<SVGElement>
): React.ReactElement<ChromeTooltipArrowProps> {
  const points = getPoints(direction).map(({ x, y }) => x + ',' + y).join(' ');
  return (
    <svg xmlns='http://www.w3.org/2000/svg'
         style={style}
         height={getHeight(direction)}
         width={getWidth(direction)}>
      <polyline points={points}
                fill={Fill}
                stroke={Stroke}
                strokeWidth={StrokeWidth} />
    </svg>
  );
}

function getHeight(direction: Direction): number {
  return direction === 'Left' || direction === 'Right' ? Height : Width;
}

function getWidth(direction: Direction): number {
  return direction === 'Left' || direction === 'Right' ? Width : Height;
}

type Point = { x: number, y: number };

type Points = Point[];

function getPoints(direction: Direction): Points {
  switch (direction) {
    case 'Up':    return [{ x: 0, y: Width }, { x: Height / 2, y: 0 }, { x: Height, y: Width }];
    case 'Down':  return [{ x: 0, y: 0 }, { x: Height / 2, y: Width }, { x: Height, y: 0 }];
    case 'Left':  return [{ x: Width, y: 0 }, { x: 0, y: Height / 2 }, { x: Width, y: Height }];
    case 'Right': return [{ x: 0, y: 0 }, { x: Width, y: Height / 2 }, { x: 0, y: Height }];
    default:      return assertNever(direction);
  }
}
